import { MinimalBadge, MinimalNumberField } from '@ovasabi/ui-minimal'
import { dayLabel, daysFrom, demand, type Board } from './model'

type Props = {
  board: Board
  location: string
  startDay: string
  disabled: boolean
  save: (kind: 'plan', payload: Record<string, unknown>) => Promise<boolean>
}

export function Week({ board, location, startDay, disabled, save }: Props) {
  const days = daysFrom(startDay)
  const dishes = board.dishes.filter((dish) => board.stock_items.some((item) => item.dish_ids.includes(dish.id)))
  return <section className="stack" aria-label="Seven day production plan">
    <div className="small-stack">
      <h2>Plan the week</h2>
      <p className="muted">Set roughly how many portions to make. It can’t go below what’s already ordered.</p>
    </div>
    {!dishes.length && <p className="empty">Add a dish to your library before planning production.</p>}
    {dishes.map((dish) => <article className="edit" key={dish.id}>
      <div className="row"><div className="small-stack"><h3>{dish.name}</h3><p className="muted">Counts paid and accepted orders for this location.</p></div><MinimalBadge tone="info">{days.reduce((sum, day) => sum + demand(board, location, day, dish.id).total, 0)} committed this week</MinimalBadge></div>
      <div className="day-grid">{days.map((day) => {
        const current = board.plans.find((plan) => plan.location_id === location && plan.day === day && plan.dish_id === dish.id)
        const committed = demand(board, location, day, dish.id).total
        return <div className="small-stack" key={day}>
          <label htmlFor={`plan-${dish.id}-${day}`}>{dayLabel(day)}</label>
          <MinimalNumberField label="Portions" min={committed} max={1000000} step={1} value={current?.quantity ?? committed} disabled={disabled} onValueCommitted={(value) => {
            if (value == null) return
            void save('plan', { location_id: location, day, dish_id: dish.id, quantity: value, expected_revision: current?.revision ?? 0 })
          }} />
          <span className="muted">{committed} committed</span>
        </div>
      })}</div>
    </article>)}
  </section>
}
